import type {RutaProd} from '../../../../runtime/rutas';
export default {ruta:'/sistema/catalogos/kits',documento:'catalogs',acceso:'sesion',filas:['061'],cita:'Areas/Catalogs/Controllers/KitsController.cs:65'} satisfies RutaProd;
